/** Runtime properties */
export interface RuntimeSettings {
	/** Unique if of this instance of Communicator Desktop */
	instanceId: string

	/** True if connection to the server has failed */
	networkError: boolean

	/** True if settings is current checking the connection to the server */
	checkForNetworkRunning: boolean

	/** The section currently displayed in the UI */
	selectedSection: SectionType | string

	/** Name of this app */
	appName: string

	/** Version of the app */
	version: string

	/** Version of the Electron app we are running inside, if in app mode */
	wrapperVersion: string

	/** URL for communicating with the wrapper app, if running inside the wrapper app, defaults to http://localhost:61337 */
	localUrl: string

	/** True if credentials shall be permanently stored - autologin - tstored locally (with token) */
	rememberMe: boolean

	/** Users email address, for easy login when rememberMe is false - stored locally */
	emailAddress?: string

	/** True if we are running embedded in the wrapper app and stuff like integrations shall run */
	isEmbedded: boolean

	/** True if embedded protocol is Electron IPC, false for HTTP port 61337 */
	isEmbeddedIpc: boolean

	/** True if we got stashed data that can be restored after impersonation has completed */
	gotStash: boolean

	/** Is the computer locked - set by wrapper app so that we can monitor and do dndWhenDesktopLocked */
	desktopLocked: boolean

	/** Is the app visible (not minimized or in background) */
	visible: boolean
}

/** Dashboard section types */
export enum SectionType {
	DASHBOARD = 'DASHBOARD',
	PHONEBOOK = 'PHONEBOOK',
	RECORDINGS = 'RECORDINGS',
	VOICEMAIL = 'VOICEMAIL',
	CALLS = 'CALLS',
	CHAT = 'CHAT',
	VIDEO = 'VIDEO'
}
